"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricsFilter = exports.GroupMetrics = exports.AppMetrics = exports.Metric = exports.MetricDataPoint = exports.MetricsDateConverter = void 0;
var createStringMapSerializers_1 = __importDefault(require("../common/createStringMapSerializers"));
var json2typescript_1 = require("json2typescript");
var MetricsDateConverter = (function () {
    function MetricsDateConverter() {
    }
    MetricsDateConverter.prototype.serialize = function (date) {
        return date.toISOString();
    };
    MetricsDateConverter.prototype.deserialize = function (date) {
        return new Date(date);
    };
    MetricsDateConverter = __decorate([
        json2typescript_1.JsonConverter
    ], MetricsDateConverter);
    return MetricsDateConverter;
}());
exports.MetricsDateConverter = MetricsDateConverter;
var MetricDataPoint = (function () {
    function MetricDataPoint(partial) {
        this.timestamp = new Date();
        this.value = 0;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('timestamp', MetricsDateConverter),
        __metadata("design:type", Date)
    ], MetricDataPoint.prototype, "timestamp", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('value'),
        __metadata("design:type", Object)
    ], MetricDataPoint.prototype, "value", void 0);
    MetricDataPoint = __decorate([
        (0, json2typescript_1.JsonObject)('DataPoint'),
        __metadata("design:paramtypes", [Object])
    ], MetricDataPoint);
    return MetricDataPoint;
}());
exports.MetricDataPoint = MetricDataPoint;
var Metric = (function () {
    function Metric(partial) {
        this.name = '';
        this.units = '';
        this.dataPoints = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name', String),
        __metadata("design:type", Object)
    ], Metric.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('units', String),
        __metadata("design:type", Object)
    ], Metric.prototype, "units", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('data_points', [MetricDataPoint]),
        __metadata("design:type", Array)
    ], Metric.prototype, "dataPoints", void 0);
    Metric = __decorate([
        (0, json2typescript_1.JsonObject)('Metric'),
        __metadata("design:paramtypes", [Object])
    ], Metric);
    return Metric;
}());
exports.Metric = Metric;
var AppMetrics = (function () {
    function AppMetrics(partial) {
        this.groupId = '';
        this.appId = '';
        this.appName = '';
        this.start = new Date();
        this.end = new Date();
        this.granularity = '';
        this.measurements = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('group_id', String),
        __metadata("design:type", Object)
    ], AppMetrics.prototype, "groupId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app_id', String),
        __metadata("design:type", Object)
    ], AppMetrics.prototype, "appId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app_name', String),
        __metadata("design:type", Object)
    ], AppMetrics.prototype, "appName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('start', MetricsDateConverter),
        __metadata("design:type", Date)
    ], AppMetrics.prototype, "start", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('end', MetricsDateConverter),
        __metadata("design:type", Date)
    ], AppMetrics.prototype, "end", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('granularity', String),
        __metadata("design:type", Object)
    ], AppMetrics.prototype, "granularity", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('measurements', [Metric]),
        __metadata("design:type", Array)
    ], AppMetrics.prototype, "measurements", void 0);
    AppMetrics = __decorate([
        (0, json2typescript_1.JsonObject)('AppMetrics'),
        __metadata("design:paramtypes", [Object])
    ], AppMetrics);
    return AppMetrics;
}());
exports.AppMetrics = AppMetrics;
var appMetricsMapSerializers = (0, createStringMapSerializers_1.default)(AppMetrics);
var AppMetricsMapConverter = (function () {
    function AppMetricsMapConverter() {
        this.serialize = appMetricsMapSerializers.serialize;
        this.deserialize = appMetricsMapSerializers.deserialize;
    }
    AppMetricsMapConverter = __decorate([
        json2typescript_1.JsonConverter
    ], AppMetricsMapConverter);
    return AppMetricsMapConverter;
}());
var GroupMetrics = (function () {
    function GroupMetrics(partial) {
        this.metricsMap = {};
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('metrics_map', AppMetricsMapConverter, true),
        __metadata("design:type", Object)
    ], GroupMetrics.prototype, "metricsMap", void 0);
    GroupMetrics = __decorate([
        (0, json2typescript_1.JsonObject)('GroupMetrics'),
        __metadata("design:paramtypes", [Object])
    ], GroupMetrics);
    return GroupMetrics;
}());
exports.GroupMetrics = GroupMetrics;
function getMetricsFilter(requestOptions) {
    if (!requestOptions) {
        return undefined;
    }
    var queryParams = {};
    if (requestOptions.start) {
        queryParams.start = requestOptions.start.toISOString();
    }
    if (requestOptions.end) {
        queryParams.end = requestOptions.end.toISOString();
    }
    if (requestOptions.period) {
        queryParams.period = requestOptions.period;
    }
    if (requestOptions.granularity) {
        queryParams.granularity = requestOptions.granularity;
    }
    if (requestOptions.metrics) {
        queryParams.metrics = requestOptions.metrics;
    }
    return queryParams;
}
exports.getMetricsFilter = getMetricsFilter;
//# sourceMappingURL=Metric.js.map